<template>
  <div class="container-xl">
    <div class="header header-search-ticket-office">
      <!--      <div class="header header-search-ticket-office d-flex align-items-center justify-content-center">-->
      <div class="row mb-5 mb-lg-0">
        <div class="col-10 offset-1">
          <form class="mt-5 form-search-ticket-office">
            <h1 class="h3">
              <strong>Wyszukiwarka</strong> kas i biletomatów
            </h1>
            <div class="row mb-4 mt-2 g-2">
              <div class="col-12 col-lg-10 ">
                <div class="position-relative form-search-ticket-office-input-container">
                  <input type="text" class="form-control" id="searchTicketsInput" placeholder="Podaj miasto" tabindex="1">
                </div>
              </div>
              <div class="col-12 col-lg-2 d-none d-lg-block">
                <button type="submit" class="btn btn-warning w-100 mb-3 w-md-25" tabindex="3">Szukaj</button>
              </div>
            </div>
            <div class="row">
              <div class="collapse" id="filterCollapse" ref="filterCollapse">
                <div class="flex-wrap justify-content-center d-flex flex-column flex-md-row">
                  <div class="me-md-2 mb-3">
                    <input type="checkbox" class="btn-check" id="searchTicketsFilter1" checked autocomplete="off"  tabindex="2">
                    <label type="label" for="searchTicketsFilter1" class="btn btn-light">Kasy krajowe</label>
                  </div>
                  <div class="me-md-2 mb-3">
                    <input type="checkbox" class="btn-check" id="searchTicketsFilter2" checked autocomplete="off"  tabindex="2">
                    <label type="label" for="searchTicketsFilter2" class="btn btn-light">Kasy międzynarodowe</label>
                  </div>
                  <div class="me-md-2 mb-3">
                    <input type="checkbox" class="btn-check" id="searchTicketsFilter3" checked autocomplete="off"  tabindex="2">
                    <label type="label" for="searchTicketsFilter3" class="btn btn-light">Biletomaty</label>
                  </div>
                  <div class="me-md-2 mb-3">
                    <input type="checkbox" class="btn-check" id="searchTicketsFilter4" checked autocomplete="off"  tabindex="2">
                    <label type="label" for="searchTicketsFilter4" class="btn btn-light">Płatność kartą</label>
                  </div>
                  <div class="me-md-2 mb-3">
                    <input type="checkbox" class="btn-check" id="searchTicketsFilter5" checked autocomplete="off"  tabindex="2">
                    <label type="label" for="searchTicketsFilter5" class="btn btn-light">Obniżony blat</label>
                  </div>
                  <div class="me-md-2 mb-3">
                    <input type="checkbox" class="btn-check" id="searchTicketsFilter6" checked autocomplete="off"  tabindex="2">
                    <label type="label" for="searchTicketsFilter6" class="btn btn-light">Pętla indukcyjna</label>
                  </div>
                  <div class="me-md-2 mb-3">
                    <input type="checkbox" class="btn-check" id="searchTicketsFilter7" checked autocomplete="off"  tabindex="2">
                    <label type="label" for="searchTicketsFilter7" class="btn btn-light">Biletomat dla osób z
                      niepełnosprawnością</label>
                  </div>
                </div>
              </div>
            </div>
            <div class="mobile-ctrl flex-column flex-lg row d-flex d-lg-none row-cols-1">
              <div class="col">
                <button class="btn btn-outline-light w-100 mb-3 w-md-25" type="button"
                        data-bs-toggle="collapse" data-bs-target="#filterCollapse" aria-expanded="false"
                        aria-controls="filterCollapse">
                  <i class="bi bi-funnel-fill"></i> Filtruj
                </button>
              </div>
              <div class="col mt-2">
                <button type="submit" class="btn btn-warning w-100 mb-3 w-md-25">Szukaj</button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'section-search-ticket-office',
  data() {
    return {
      collapseVisible: true,
      collapseBS: {},
      isMobile: false,
    }
  },
  methods: {
    handleResize() {
      this.$nextTick(() => {
        this.isMobile = window.innerWidth < 992;
      })
    }
  },
  watch: {
    isMobile: function () {
      //console.log("isMobile");
      if (this.isMobile === true && this.collapseVisible === true) {
        this.collapseVisible = false;
        this.collapseBS.hide();
      } else if (this.isMobile === false && this.collapseVisible === false) {
        this.collapseBS.show();
        this.collapseVisible = true;
      }
    }
  },
  mounted: function () {
    this.isMobile = window.innerWidth < 992;
    this.collapseBS = new bootstrap.Collapse(this.$refs.filterCollapse, {toggle: !this.isMobile });
    this.handleResize();
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy: function () {
    window.removeEventListener('resize', this.handleResize)
  }
}
</script>